import { useState } from "react";
import styled from "styled-components";
import { Form, Input, Button, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import logo from "../assets/logo.png";
import { useResetPasswordMutation } from "../hooks/graphql/graphql";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;
const StyledContainer = styled.div`
  margin-top: 25px;
  text-align: left;
  width: 25rem;
  padding: 38px 30px 25px;
  border-radius: 2px;
  border-top: 2px solid #fc5000;
  box-shadow: rgb(227 233 243) 0px 2px 4px 0px;
`;
const StyledImg = styled.img`
  margin-top: 76px;
`;

const ResetPassword = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const params = useParams<{ email: string; otp: string }>();
  const resetPassword = useResetPasswordMutation();

  const onFinish = async (values: any) => {
    try {
      setSubmitting(true);
      const { data } = await resetPassword[0]({
        variables: {
          email: params.email!,
          newPassword: values.password,
          otp: params.otp!,
        },
      });
      if (!data?.resetPasswordWithEmailOTP.status) {
        setError(data?.resetPasswordWithEmailOTP.message!);
      } else {
        navigate(`/login`);
      }
      setSubmitting(false);
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = () => {
    setError("");
  };
  return (
    <StyledWrapper>
      <div>
        <StyledImg src={logo} alt="logo" />
        <StyledContainer>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onValuesChange={onValuesChange}
          >
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirm"
              label="Confirm Password"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "The two passwords that you entered do not match!"
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            {error && <Typography.Text type="danger">{error}</Typography.Text>}
            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                disabled={submitting}
              >
                {submitting ? "..." : "Reset Password"}
              </Button>
            </Form.Item>
          </Form>
        </StyledContainer>
      </div>
    </StyledWrapper>
  );
};

export default ResetPassword;
